import { Role } from "../../helpers/role";

export const InventoryRoutes = [
  {
    name: "InventoryRoutes",
    path: `/${Role.Inventory}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "InventoryIndex",
        path: "/",
        component: () => import("@/views/inventory/Dashboard"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventorySeach",
        path: "search",
        component: () => import("@/views/inventory/SearchInventory"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventoryDashboard",
        path: "dashboard",
        component: () => import("@/views/inventory/Dashboard"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventoryActivatedList",
        path: "activated",
        component: () => import("@/views/inventory/ActivatedList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventoryOnhand",
        path: "onhand",
        component: () => import("@/views/inventory/OnhandList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventoryReleasedList",
        path: "released",
        component: () => import("@/views/inventory/ReleasedList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },

      {
        name: "InventoryDefectiveList",
        path: "defective",
        component: () => import("@/views/inventory/DefectiveList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },
      {
        name: "InventoryReturnedList",
        path: "returned",
        component: () => import("@/views/inventory/ReturnedList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },
      {
        name: "InventoryRegisteredList",
        path: "registered",
        component: () => import("@/views/inventory/RegisteredList"),
        meta: {
          authorize: [Role.Inventory],
        },
      },
    ],
  },
];
